
<script setup>
import { ref } from 'vue';
import { Inertia } from '@inertiajs/inertia';
import { Head, Link } from '@inertiajs/inertia-vue3';

import Nav from '@/Layouts/ShopLte/Nav.vue';
import Sidebar from '@/Layouts/ShopLte/Sidebar.vue';

import '@/../scss/shop/shop.scss?inline';

defineProps({
    title: String,
});

const showingNavigationDropdown = ref(false);

const switchToTeam = (team) => {
    Inertia.put(route('current-team.update'), {
        team_id: team.id,
    }, {
        preserveState: false,
    });
};

const logout = () => {
    Inertia.post(route('logout'));
};
</script>

<template>
    <div class="app-wrapper">
        <Head :title="title" />

        <Nav></Nav>
        <Sidebar></Sidebar>

        <div class="content-wrapper px-4 py-2">
            <notifications />
            <slot />
        </div>
    </div>
</template>

<style>

.vue-notification-group{
    top:62px!important;
}


.nav-sidebar>.nav-item>.nav-link {
    font-weight: bold;
    color: #343a40;
    border-radius: 10px;
    &.active{
        color: white;
    }
}

.nav-sidebar>.nav-item .nav-icon {
    font-size: 14px;
}
</style>
